<script lang="ts">
  import cssVars, { cssVarsAsStyles } from "../../utils/cssVars";

  /**
   * Starting point in the grid for the small breakpoint
   *
   * @defaultValue `1`
   */
  export let smStart: number = 1;
  /**
   * Starting point in the grid for the medium breakpoint
   *
   * @defaultValue `1`
   */
  export let mdStart: number = 1;
  /**
   * Starting point in the grid for the large breakpoint
   *
   * @defaultValue `1`
   */
  export let lgStart: number = 1;
  /**
   * Starting point in the grid for the xl breakpoint
   *
   * @defaultValue `lgStart`
   */
  export let xlStart: number = lgStart;
  /**
   * Starting point in the grid for the xxl breakpoint
   *
   * @defaultValue `xlStart`
   */
  export let xxlStart: number = xlStart;
  /**
   * Number of columns it should expand from its starting point for the small breakpoint
   */
  export let smSpan: number;
  /**
   * Number of columns it should expand from its starting point for the medium breakpoint
   */
  export let mdSpan: number;
  /**
   * Number of columns it should expand from its starting point for the large breakpoint
   */
  export let lgSpan: number;
  /**
   * Number of columns it should expand from its starting point for the xl breakpoint
   */
  export let xlSpan: number = lgSpan;
  /**
   * Number of columns it should expand from its starting point for the xxl breakpoint
   */
  export let xxlSpan: number = xlSpan;
  /**
   *  Number of rows this column should expand from its starting point for the sm breakpoint
   *
   * @defaultValue `1`
   */
  export let smRowSpan: number = 1;
  /**
   * Number of rows this column should expand from its starting point for the md breakpoint
   *
   * @defaultValue `1`
   */
  export let mdRowSpan: number = 1;
  /**
   * Number of rows this column should expand from its starting point for the lg breakpoint
   *
   * @defaultValue `1`
   */
  export let lgRowSpan: number = 1;
  /**
   * Number of rows this column should expand from its starting point for the xl breakpoint
   *
   *  @defaultValue `lgRowSpan`
   */
  export let xlRowSpan: number = lgRowSpan;
  /**
   * Number of rows this column should expand from its starting point for the xxl breakpoint
   *
   *  @defaultValue `xlRowSpan`
   */
  export let xxlRowSpan: number = xlRowSpan;

  $: styleVars = {
    smStart,
    mdStart,
    lgStart,
    xlStart,
    xxlStart,
    smSpan,
    mdSpan,
    lgSpan,
    xlSpan,
    xxlSpan,
    smRowSpan,
    mdRowSpan,
    lgRowSpan,
    xlRowSpan,
    xxlRowSpan,
  };
</script>

<style lang="scss">
  div {
    grid-column-start: var(--smStart);
    grid-column-end: span var(--smSpan);
    grid-row: span var(--smRowSpan);
    width: 100%;
  }

  @media (min-width: $md) {
    div {
      grid-column-start: var(--mdStart);
      grid-column-end: span var(--mdSpan);
      grid-row: span var(--mdRowSpan);
    }
  }
  @media (min-width: $lg) {
    div {
      grid-column-start: var(--lgStart);
      grid-column-end: span var(--lgSpan);
      grid-row: span var(--lgRowSpan);
    }
  }

  @media (min-width: $xl) {
    div {
      grid-column-start: var(--xlStart);
      grid-column-end: span var(--xlSpan);
      grid-row: span var(--xlRowSpan);
    }
  }

  @media (min-width: $xxl) {
    div {
      grid-column-start: var(--xxlStart);
      grid-column-end: span var(--xxlSpan);
      grid-row: span var(--xxlRowSpan);
    }
  }
</style>

<div use:cssVars={styleVars} style={cssVarsAsStyles(styleVars)} {...$$props}>
  <slot />
</div>
